import template from './print_physical_cash_count.html';
import controller from './print_physical_cash_count.controller';
import './print_physical_cash_count.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/physical_cash_count/print/print_physical_cash_count.component.js